/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import ProgressBar, { IProgress } from "components/ui/ProgressBar/Progress";
import React from "react";
import Interval from "utils/Interval";

interface IUseProgress {
  (props?: {
    delay?: number;
    increment?: number;
  }): [React.FC<Pick<IProgress, "size">>];
}

const useProgress: IUseProgress = (options) => {
  const settings = { delay: 50, increment: 5 };
  if (options) {
    Object.assign(settings, options);
  }

  const { delay, increment } = settings;
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const interval = new Interval();
    interval.start(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          interval.stop();
          return 100;
        }

        return prev + increment;
      });
    }, delay);

    return () => {
      interval.stop();
    };
  }, []);

  const Progress = React.useMemo(() => {
    return (props: Pick<IProgress, "size">) => (
      <ProgressBar value={progress} size={props.size} test-id="BYH8xChm" />
    );
  }, [progress]);

  return [Progress];
};

export default useProgress;
